import getUserAdvancedStore from ".";
import { apiCallAddAdminUsersComments } from "../../../api/user-api/api-call-add-user-admin-comments";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";

const addAdminUserComments = async (userID: number, commentText: string) => {
  try {
    getCoreUIStore().setIsLoading("USER_ADVANCED", true);
    const { data, status, code } = await apiCallAddAdminUsersComments({
      userID,
      commentText
    });
    getCoreUIStore().setIsLoading("USER_ADVANCED", false);
    if (status === "OK") {
      getUserAdvancedStore().addComment(userID, commentText);
      return data;
    }
    getCorePopUpStore().showAlertMessage(code);
    return code;
  } catch (error) {
    return error;
  }
};

export default addAdminUserComments;
